import utils from "Sources/utils/utils";
import request from "Sources/services/request";

let StudentService = {};

((StudentService) =>
{
  StudentService.createStudent = function(classKey, studentName)
  {
    return request.post({
      url:  utils.getServiceUrl("/students"),
      cache: false,
      data: {
        "class-key": classKey,
        "name": studentName
      }
    })
      .then((data) =>
      {
        let rtrnData = null;

        if(utils.isNotNull(data) && data.result === "success" && data.data)
        {
          rtrnData = data.data;
        }

        return rtrnData;
      });
  };

  StudentService.updateStudent = function(studentKey, studentName)
  {
    return request.put({
      url:  utils.getServiceUrl("/students/" + studentKey),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
      data: {
        key : studentKey,
        name: studentName
      }
    })
      .then((data) =>
      {
        let rtrnData = null;

        if(utils.isNotNull(data) && data.result === "success" && data.data)
        {
          rtrnData = data.data;
        }

        return rtrnData;
      });
  };

  StudentService.deleteStudent = function(studentKey)
  {
    return request.delete({
      url:  utils.getServiceUrl("/students/" + studentKey),
      cache: false
    })
      .then((data) =>
      {
        let rtrnData = null;

        if(utils.isNotNull(data) && data.result === "success" && data.data)
        {
          rtrnData = data.data;
        }

        return rtrnData;
      });
  };

})(StudentService);

module.exports = StudentService;



// WEBPACK FOOTER //
// ./app/js/services/student-service.js